module.exports = __webpack_public_path__ + "img/improved-intervention.436a275f.svg";